import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as reducers from 'Store/reducers';
import { sendAnalyticsEventById } from 'Store/stats/actions';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import TrialActivationBanner from 'Components/TrialActivationBanner';
import PromotionalBanner from 'Components/PromotionalBanner';
import Button from 'Components/Button';
import { ROUTES } from 'Settings/route-strings';

class ExplorePageBanners extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showWelcomeBanner: this.shouldShowBanner(),
      welcomeBannerHidWhileMounted: false,
    };

    this.closeBanner = this.closeBanner.bind(this);
    this.clickBanner = this.clickBanner.bind(this);
    this.shouldShowBanner = this.shouldShowBanner.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const showWelcomeBanner = this.shouldShowBanner();
    if (prevState.showWelcomeBanner !== showWelcomeBanner) {
      this.setState({ showWelcomeBanner });
    }
  }

  closeBanner() {
    this.props.sendAnalyticsEventById(
      'onboarding_welcome_banner',
      'clicked close'
    );
    this.setState({ welcomeBannerHidWhileMounted: true });
  }

  clickBanner(e) {
    e.preventDefault();
    this.props.sendAnalyticsEventById(
      'onboarding_welcome_banner',
      'clicked button'
    );
    this.props.history.push(`${ROUTES.EXPLORE}/human-body`);
  }

  shouldShowBanner() {
    const { activeUser, seenWelcomeBanner } = this.props;

    // If they have seen the banner, are not a teacher, or are a very old user, hide the banner.
    if (
      seenWelcomeBanner === true ||
      !activeUser.created_at ||
      activeUser.isStudent
    )
      return false;

    // If the user was created after April 8th, 2018, show the banner.
    // TODO: Move this into a reducer or something.
    const welcomeBannerCutoff = new Date(2018, 3, 8);
    const createdDate = new Date(activeUser.created_at);
    return createdDate > welcomeBannerCutoff;
  }

  render() {
    const { showWelcomeBanner, welcomeBannerHidWhileMounted } = this.state;
    const { activeUser } = this.props;
    return (
      <React.Fragment>
        {!showWelcomeBanner && !welcomeBannerHidWhileMounted ? (
          <TrialActivationBanner activeUser={activeUser} />
        ) : null}
        <PromotionalBanner
          type="signup-welcome"
          visible={showWelcomeBanner}
          headline={
            <ConnectedFormattedMessage id="promotional_banner.signup-welcome.headline" />
          }
          closeHandler={() => this.closeBanner()}
          hasGraphic
          ctaButton={
            <Button
              buttonType="primary-mono"
              label={
                <ConnectedFormattedMessage id="promotional_banner.signup-welcome.button_label" />
              }
              clickHandler={this.clickBanner}
            />
          }
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    activeUser: reducers.getActiveUser(state),
    seenWelcomeBanner: reducers.getHasUIHintBeenSeen(
      state,
      'onboarding_welcome_banner'
    ),
  };
};

ExplorePageBanners.propTypes = {
  activeUser: PropTypes.object.isRequired,
  seenWelcomeBanner: PropTypes.bool.isRequired,
  sendAnalyticsEventById: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(
  connect(mapStateToProps, { sendAnalyticsEventById })(ExplorePageBanners)
);
